import { CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Departamento } from '../api.service';

@Component({
  selector: 'app-seletor-multiplo-departamentos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './seletor-multiplo-departamentos.component.html',
  styleUrls: ['./seletor-multiplo-departamentos.component.css']
})
export class SeletorMultiploDepartamentosComponent implements AfterViewChecked {
  @Input() departamentos: Departamento[] = [];
  @Input() idsSelecionados: string[] = [];
  @Input() desabilitado = false;
  @Input() rotuloTodos = 'Todos os departamentos';

  @Output() idsSelecionadosChange = new EventEmitter<string[]>();

  @ViewChild('caixaTodos') caixaTodos?: ElementRef<HTMLInputElement>;

  aberta = false;

  constructor(private readonly elemento: ElementRef<HTMLElement>) {}

  get todosSelecionados() {
    return this.departamentos.length > 0 && this.idsSelecionados.length === this.departamentos.length;
  }

  get algunsSelecionados() {
    return this.idsSelecionados.length > 0 && !this.todosSelecionados;
  }

  get rotuloSelecao() {
    if (!this.idsSelecionados.length || this.todosSelecionados) {
      return this.rotuloTodos;
    }
    if (this.idsSelecionados.length === 1) {
      return this.departamentos.find(item => item.id === this.idsSelecionados[0])?.nome || this.rotuloTodos;
    }
    return `${this.idsSelecionados.length} departamentos`;
  }

  ngAfterViewChecked() {
    if (this.caixaTodos) {
      this.caixaTodos.nativeElement.indeterminate = this.algunsSelecionados;
    }
  }

  @HostListener('document:click', ['$event'])
  fecharFora(evento: MouseEvent) {
    if (!this.aberta) {
      return;
    }
    if (!this.elemento.nativeElement.contains(evento.target as Node)) {
      this.aberta = false;
    }
  }

  alternar() {
    if (this.desabilitado) {
      return;
    }
    this.aberta = !this.aberta;
  }

  marcado(departamentoId?: string) {
    return !!departamentoId && this.idsSelecionados.includes(departamentoId);
  }

  alternarTodos() {
    this.emitir(this.todosSelecionados ? [] : this.departamentos.map(item => item.id || '').filter(Boolean));
  }

  alternarItem(departamentoId: string | undefined, marcado: boolean) {
    if (!departamentoId) {
      return;
    }
    const ids = this.idsSelecionados.filter(id => id !== departamentoId);
    if (marcado) {
      ids.push(departamentoId);
    }
    this.emitir(ids);
  }

  private emitir(ids: string[]) {
    this.idsSelecionados = ids;
    this.idsSelecionadosChange.emit([...ids]);
  }
}
